import React from 'react';
import { BaseDesignRegistrationPanelProps, DesignRegistrationPanel } from 'common/components';
import { ENTRANCE_DOORS_ELEMENT_BLOCK } from '../../entrance-doors-constants';
import { ENTRANCE_DOORS_PANEL_STRUCTURE } from './entrance-doors-design-panel-constants';

export const EntranceDoorsDesignPanel: React.FC<BaseDesignRegistrationPanelProps> = ({
  isConsultationFormVisible,
  onConsultationSignupBtnClick,
}) => (
  <DesignRegistrationPanel
    isConsultationFormVisible={isConsultationFormVisible}
    structure={{
      panel: {
        ...ENTRANCE_DOORS_PANEL_STRUCTURE.panel,
        actionBlock: [
          {
            elementBlock: ENTRANCE_DOORS_ELEMENT_BLOCK,
            label: 'Записаться на консультацию',
            onClick: onConsultationSignupBtnClick,
            variant: 'accent',
          },
        ],
      },
      mobilePanel: {
        ...ENTRANCE_DOORS_PANEL_STRUCTURE.mobilePanel,
        mobileButton: {
          ...ENTRANCE_DOORS_PANEL_STRUCTURE.mobilePanel.mobileButton,
          onClick: onConsultationSignupBtnClick,
        },
      },
    }}
  />
);
